export default function ($scope, timetableService, storageService) {

    this.recent = storageService.getRecent();

    /**
     * Receive model updates when the recent courses object is updated in the service
     */
    timetableService.subscribe($scope, 'recentChanged', (e, arg) => this.recent = arg);

    if (this.recent.length) {

        // Get a list of history objects to be validated against the server side
        // exclude recent objects representing saved searches - only valid course items
        var validationData = this.recent.filter((v, i) => {
            v.index = i;
            return v.description;
        }).map(v => {
            return { courseCode: v.courseCode, termId: v.termId, index: v.index };
        });

        var fromSearch = this.recent.filter((v, i) => {
            v.index = i;
            return !v.description;
        });

        // possible we have no courses to check
        if (validationData.length) {
            // Call the server to get the course and term changes in the recently viewed
            timetableService.getValidatedCourseTerms(validationData).then(removalList => {
                var item,
                    i,
                    y;

                if (removalList.status.toLowerCase() === 'success' &&
                    removalList.data &&
                    removalList.data.length > 0) {
                    // We have recieved some items to remove from the recently viewed list as they are no longer available.
                    for (i = 0; i < removalList.data.length; i++) {
                        item = removalList.data[i];
                        for (y = 0; y < this.recent.length; y++) {
                            if (this.recent[y].courseCode === item.courseCode &&
                                this.recent[y].termId === item.termId) {
                                this.recent.splice(y, 1);
                            }
                        }
                    }

                    if (fromSearch.length) {
                        fromSearch.forEach(v => this.recent.splice(v.index, 0, v));
                    }

                    storageService.storeRecent(this.recent);
                }
            });
        }
    }
};